<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { TabSize } from './TabProps';

  interface Props {
    list: CommonList[];
    active?: string;
    disabled?: boolean;
    size?: TabSize;
    children?: import('svelte').Snippet;
    onclick?: (detail: CommonList) => void;
  }

  let { list, active = '', disabled = false, size = TabSize.Medium, children, onclick }: Props = $props();

  const onClickTabItem = (item: CommonList): void => {
    onclick?.(item);
  };
</script>

<div class="comp-tab">
  {#each list as item}
    <button
      type="button"
      class="tab-i {size}"
      data-cy={item.id}
      {disabled}
      class:active={active === item.id}
      onclick={() => onClickTabItem(item)}
    >
      {#if item.icon}
        <div class="icon">
          <div class="default"><Icon value="{item.icon} grey" /></div>
          <div class="active"><Icon value="{item.icon} active" /></div>
        </div>
      {/if}
      <div class="text">{item.label}</div>
    </button>
  {/each}

  {@render children?.()}
</div>

<style>
  .comp-tab {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }

  .tab-i {
    margin-right: 20px;
    font-weight: 500;
    font-size: 14px;
    color: var(--grey-medium);
    padding-bottom: 16px;
    position: relative;
    display: flex;
    align-items: center;
  }
  .tab-i.size-sm {
    font-size: 12px;
  }
  .tab-i.size-md {
    font-size: 14px;
  }
  .tab-i.size-lg {
    font-size: 16px;
  }
  .tab-i.active,
  .tab-i:hover {
    color: var(--blue);
  }
  .tab-i::after {
    content: '';
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: transparent;
  }
  .tab-i.active::after {
    background-color: var(--blue);
  }
  .tab-i .icon,
  .tab-i .icon .default,
  .tab-i .icon .active {
    display: flex;
    align-items: center;
  }

  .tab-i .icon {
    margin-right: 8px;
  }
  .tab-i .icon .active {
    display: none;
  }
  .tab-i:hover .icon .active,
  .tab-i.active .icon .active {
    display: flex;
  }
  .tab-i:hover .icon .default,
  .tab-i.active .icon .default {
    display: none;
  }
  .tab-i:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
